/**
 * The API follows https://developer.piwik.org/api-reference/tracking-javascript
 */
interface PiwikTracker {
  trackSiteSearch(
    keyword: string,
    category?: string,
    resultsCount?: number
  ): void;
  trackEvent(
    category: string,
    action: string,
    name?: string,
    value?: string
  ): void;
  setUserId(id: string): void;
}

/**
 * Browsers with Ad Blocker will instantiate this.
 */
class DummyPiwik {
  getAsyncTracker(): PiwikTracker {
    return {
      trackSiteSearch() {},
      trackEvent() {},
      setUserId() {},
    };
  }
}

/**
 * `window.Piwik` is defined only when piwik.js is successfully fetched and loaded from
 * analytics.sourcesage.co.
 *
 * For ad blockers that block downloading of piwik.js files, we instantiate
 * a dummy object that has the same interface as the actual `window.Piwik` from piwik.js.
 */
const piwikTracker: PiwikTracker = window.hasOwnProperty('Piwik')
  ? (window as any).Piwik.getAsyncTracker()
  : new DummyPiwik().getAsyncTracker();

export default piwikTracker;



// WEBPACK FOOTER //
// ./app/utils/piwik/index.ts